import React from "react";

const ViewService = ({ viewData }) => {
  return (
    <>
      <div className="row  mb-1  row_div pt-4 px-4">
        <div className="form-group col-sm-4 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Content Provider Name</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.cpName}</div>
          </div>
        </div>
        <div className="form-group col-sm-4 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Country</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.countryName}</div>
          </div>
        </div>
        <div className="form-group col-sm-4 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Operator</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.operatorName}</div>
          </div>
        </div>
        <div className="form-group col-sm-4 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Service Type</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.serviceType}</div>
          </div>
        </div>
        <div className="form-group col-sm-4 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Service Name</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.serviceName}</div>
          </div>
        </div>
        <div className="form-group col-sm-4 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Service Name Arabic</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">
              {viewData?.serviceNameArabic}
            </div>
          </div>
        </div>
        <div className="form-group col-sm-4 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Portal Link</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.portalAndAppLink}</div>
          </div>
        </div>
        <div className="form-group col-sm-4 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Service Description</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">
              {viewData?.serviceDescription}
            </div>
          </div>
        </div>
        <div className="form-group col-sm-4 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Service Description Arabic</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">
              {viewData?.serviceNameArabic}
            </div>
          </div>
        </div>
        <div className="form-group col-sm-4 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Operator Share</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.operatorShare}</div>
          </div>
        </div>
        <div className="form-group col-sm-4 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Aggregate Share</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.aggregatorShare}</div>
          </div>
        </div>
        <div className="form-group col-sm-4 mb-0">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Partner Share</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.partnerShare}</div>
          </div>
        </div>
      </div>

      {/* <div className="row mb-1  row_div pt-4 px-4">
        
        <div className="form-group col-sm-4">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Service Type</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.serviceType}</div>
          </div>
        </div>
        <div className="form-group col-sm-4">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Service Name</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.serviceName}</div>
          </div>
        </div>
        <div className="form-group col-sm-4">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Service Name Arabic</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">
              {viewData?.serviceNameArabic}
            </div>
          </div>
        </div>
      </div> */}


      {/* <div className="row mb-1  row_div pt-4 px-4">
        <div className="form-group col-sm-4">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Portal Link</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.portalAndAppLink}</div>
          </div>
        </div>
        <div className="form-group col-sm-4">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Service Description</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">
              {viewData?.serviceDescription}
            </div>
          </div>
        </div>
        <div className="form-group col-sm-4">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Service Description Arabic</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">
              {viewData?.serviceNameArabic}
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="row  mb-1  row_div pt-4 px-4"> */}
        {/* <div className="col-sm-4">
          <div className="row">
            <div className="col-sm-6 label"><span>Service Description Arabic</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">
              {viewData?.serviceNameArabic}
            </div>
          </div>
        </div> */}
        {/* <div className="form-group col-sm-4">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Operator Share</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.operatorShare}</div>
          </div>
        </div>
        <div className="form-group col-sm-4">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Aggregate Share</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.aggregatorShare}</div>
          </div>
        </div>
      </div> */}

      {/* <div className="row  mb-1  row_div pt-4 px-4">
       
        <div className="form-group col-sm-4">
          <div className="row mobile-line-row">
            <div className="col-sm-6 label"><span>Partner Share</span><span>:</span></div>
            <div className="col-sm-6 fw-bold text-wrap cont_div">{viewData?.partnerShare}</div>
          </div>
        </div>
      </div> */}
    </>
  );
};

export default ViewService;
